/* eslint-disable */
import { isNumeric } from './my_utils.js'
class Validator {

  isNumeric (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }
  
  validateEmail(field) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(field.value.trim());
  }

  validateExists(field) {
    return ((field.value + '').trim().length > 0) && (field.value != null)
  }

  validatePositive(field) {
    return Number(field.value) > 0;
  }

  validateNumber(field) {
    if(field.value == undefined){
      return true
    }
    return this.isNumeric(field.value)
  }

  validateExists(field) {
    return ((field.value + '').trim().length > 0) && (field.value != null)
  }

}

export default Validator;
